import type { FC } from "react";
import { Button } from "@mantine/core";
import {
  IconDownload,
  IconFileCertificate,
  IconMessagePlus,
  IconRotate,
  IconTruck,
  IconTruckOff,
  type Icon,
} from "@tabler/icons-react";
import type { OrderPageState } from "../useOrderPage";
import { ICON_STROKE } from "./order-page-v2.utils";

const buttonIcon = (ButtonIcon: Icon) => (
  <ButtonIcon size={14} stroke={ICON_STROKE} />
);

type OrderDetailActionsProps = {
  state: OrderPageState;
};

export const OrderDetailActions: FC<OrderDetailActionsProps> = ({ state }) => {
  const { order, permissions, modals, requests, actions } = state;
  const { activePickupId, latestPickupFile } = state.pickup;

  if (!order) {
    return null;
  }

  return (
    <>
      {permissions.canComment && (
        <Button
          variant="outline"
          leftSection={buttonIcon(IconMessagePlus)}
          onClick={() =>
            requests.help.opened
              ? requests.help.close()
              : actions.openHelpRequest()
          }
        >
          Ajouter une précision
        </Button>
      )}
      {permissions.canRequestRedo && (
        <Button
          variant="outline"
          leftSection={buttonIcon(IconRotate)}
          onClick={requests.redo.toggle}
        >
          Demander une refabrication
        </Button>
      )}
      {permissions.canDownloadDeliveryProof && (
        <Button
          variant="outline"
          leftSection={buttonIcon(IconFileCertificate)}
          onClick={() => actions.downloadDeliveryProof(order.orderReference)}
        >
          Preuve de livraison
        </Button>
      )}
      {activePickupId && latestPickupFile && (
        <Button
          variant="outline"
          leftSection={buttonIcon(IconDownload)}
          onClick={() => actions.downloadFile(latestPickupFile)}
        >
          Étiquette de ramassage
        </Button>
      )}
      {activePickupId && (
        <Button
          variant="outline"
          leftSection={buttonIcon(IconTruckOff)}
          onClick={() => actions.abortPickup(activePickupId)}
        >
          Annuler le ramassage
        </Button>
      )}
      {permissions.canRequestPickup && (
        <Button
          variant="outline"
          leftSection={buttonIcon(IconTruck)}
          onClick={modals.pickup.open}
        >
          Demander un ramassage
        </Button>
      )}
    </>
  );
};
